//Solo pide los parametros para generar algunos reportes de caja  
//Entre esos reportes: IngresosResumen,IngresosDetallado,EgresosResumen,EgresosDetallado,Balance efectivo
//en estos reportes ya está habilitado que si desea CONSOLIDADO o solo éste Establecimiento.  
//Las fechas yo quería mandarlas con hora también, para que se parezca a VINOTINTO (pero mejor en el futuro)
//luego me devuelvo al menu principal y desde ahi llamo realmente al componente del reporte correspondiente
//====== aqui se pide ======
//Fecha inicial
//Fecha final
//Usuario para filtrar los datos ('todos','admin','titi')
//Establecimiento para filtrar los datos ('000','001','002'). Al poner '000'-> significa CONSOLIDADO
//tambien le mando el login del usuario logeado (este dato solo me sirve para guardar en disco con ese nombre)

import React, {useState,useEffect} from 'react'
import {Modal,ModalHeader,ModalBody,ModalFooter,Form,FormGroup,Button,ButtonGroup,Input,Label} from 'reactstrap'
//Para las pestanas TAB y otros
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap'
import { convierteObjetoFechaDeJSenTexto,textoDelCombo,limpiarCombo, formatearFechaDesdeDDMMYYYY_a_YYYYMMDD } from './lib_basica'
import {gestionarCatch,mostrarSwalEspera,apagarSwal,mostrarSwalBotonAceptar,mostrarSwalUnSegundo,mostrarConfirmacionEliminarAnular,mostrarSwalReintentar } from './lib_basica'
//awensome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCheckSquare, faWindowClose,faFileInvoiceDollar,faListOl,faPercent,faLayerGroup, faCubes,faSearch,faMinus,faPlusCircle,faPlus,faCheckCircle,faCheck,faTimes,faTimesCircle,faBookReader,faUserAlt,faUser,faUserPlus,faUserAltSlash,faEnvelope,faCommentDollar, faDollarSign, faMoneyBill, faEye,  faAddressCard, faPrint, faFileExcel,faEdit,faReplyAll,faTrashAlt,faEllipsisH,faSyncAlt, faBalanceScaleRight } from '@fortawesome/free-solid-svg-icons' 
//del context
import {AppContextConsumer} from './ContextBase'
//************** React-DatePicker ******/
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import es from 'date-fns/locale/es' //'es' sirve para que los nombres de los meses salgan en espanol
registerLocale('es',es) //obligatorio

export default function PantNegraReportesCaja_Varios(props){   
let valueDC=null //Esta variable me sirve para tener una copia de los valores del context  
const [fechaIniCaja,setfechaIniCaja]=useState(null)
const [fechaFinCaja,setfechaFinCaja]=useState(null)
const [miTitulo,setmiTitulo]=useState("")
let jsonNegra={} //aqui guardo las opciones seleccionadas por el usuario

const ponerTitulo=()=>{
  switch (props.tipoDeReporte) {
    case "caja_ingresos_detallado":
      setmiTitulo("Ingresos por forma de pago (detallado)")
    break;
    case "caja_ingresos_resumen":
      setmiTitulo("Ingresos por forma de pago (resumen)")
    break;
    case "caja_egresos_detallado":
      setmiTitulo("Egresos por forma de pago (detallado)")
    break;
    case "caja_egresos_resumen":
      setmiTitulo("Egresos por forma de pago (resumen)")
    break;
    case "caja_balance_efectivo":
      setmiTitulo("Balance en efectivo")
    break;        
}
}
//el useEffect me simula el didMount (siempre y cuando los corchetes [] esten vacios) 
//al no tener los corchetes [] entonces se ejecuta cada vez que alguna variable de estado cambie
//pero si por ejemplo pongo [fecha], entonces el useEffect se actualiza cada vez que fecha cambie
//[] se refiere a la lista de dependencias

//************ simulo el componentDidMount */
useEffect( ()=>{
  ponerTitulo()

  //El boton de Excel, podria no estar visible en algunos casos
  if (props.botonExcelSN=="N")
    document.getElementById("btnExcel").style.visibility= 'hidden' //pero Lo botones visibles se quedan en su lugar original
    
  //prendo los radios por defecto
  document.getElementById("usuariosTodos").setAttribute("checked","true")
  document.getElementById("establecimientosTodos").setAttribute("checked","true")

  ponerFechasPorDefecto()
  alimentarCombos()

},[]
)

//desmontaje
/*
useEffect( ()=>{
  // codigo normal....
  // codigo normal ....
  // codigo normal....
  return () =>{
  // remover addEventListener
  // desuscribirte de api's
//{copiarVariablesDesdeContext(value)}
  }
  }  
)
*/

const ponerFechasPorDefecto=()=>{
  let miCurrentTime = new Date()
  let miAno = miCurrentTime.getFullYear()
  let miMes = miCurrentTime.getMonth() //OJO: al hacer esto: DICIEMBRE ES 11 
  let miDia = miCurrentTime.getDate() //devuelve el dia del mes [1..31]
  setfechaIniCaja(new Date(miAno,miMes,1))   
  setfechaFinCaja(new Date(miAno,miMes,miDia))
}

const alimentarCombos=()=>{
//cargo el comboUsuarios
let miComboUsu= document.getElementById("comboUsuarios")
limpiarCombo(miComboUsu) //primero lo limpio 
valueDC.usuarios.forEach( (item) => {
  if (item.ActivoUsu==1){
    let miOption=document.createElement("option")
    miOption.value= item.LoginUsu
    miOption.text=item.LoginUsu
    miComboUsu.appendChild(miOption)
  }
})

//cargo el comno de establecimientos
let miComboEstab= document.getElementById("comboEstablecimientos")
limpiarCombo(miComboEstab) //primero lo limpio 
valueDC.establecimientos.forEach( (item) => {
  if (item.Abierto==1){
    let miOption=document.createElement("option")
    miOption.value= item.Estab
    miOption.text=item.Estab
    miComboEstab.appendChild(miOption)
  }
})
//al combo lo pongo a que no apunte a nadie
miComboUsu.value=0
miComboEstab.value=0
}

const salir=(botonEP)=>{
//el botonEP, puede venir con ["E"xcel / "P"df]
//valido que la fecha fin sea mayor/igual que fecha ini
let fechasOK=(fechaFinCaja>=fechaIniCaja)
if (!fechasOK){
  mostrarSwalBotonAceptar("error","ATENCION","La fecha final debe ser mayor que la inicial")
  return false
}

  //guardo las opciones del usuario 
  //rosa tr
  //(antes estaba asi, pero no funcionó cuando se implementaron los reportes de caja)
  //jsonNegra.fechaIni=convierteObjetoFechaDeJSenTexto(fechaIni) 
  //jsonNegra.fechaFin=convierteObjetoFechaDeJSenTexto(fechaFin) 

  jsonNegra.fechaIni=formatearFechaDesdeDDMMYYYY_a_YYYYMMDD((document.getElementById("txtDesdeCaja").value).trim())
  jsonNegra.fechaFin=formatearFechaDesdeDDMMYYYY_a_YYYYMMDD((document.getElementById("txtHastaCaja").value).trim()) 

//usuarios
if (document.getElementById("usuariosTodos").checked)
  jsonNegra.usuarios="todos" //todos
else
  jsonNegra.usuarios=document.getElementById("comboUsuarios").value

//establecimientos
if (document.getElementById("establecimientosTodos").checked){
  jsonNegra.establecimientos="000" //consolidado
}
else{
  jsonNegra.establecimientos=document.getElementById("comboEstablecimientos").value  //codigo del estab
}

//cierro y regreso al llamador
props.cerrarModal(true,jsonNegra,botonEP)  
}

return(
<AppContextConsumer>
{value =>{         
valueDC=value //copio el context a una varible propia
return(
<div id="divMaster" name="divMaster" className='FondoCasiNegro'>    
 {/* Titulo + Boton Cerrar */}
 <Row style={{margin:'0',}}>
    <Col xs="10" >
      <Label id="labelTitulo" name="labelTitulo" style={{marginTop:'5px',color:'dimGray',fontWeight: 'bold'}}>{miTitulo}</Label>
    </Col>
    <Col xs="2" style={{textAlign:'right',padding:'0'}}>
      <Button style={{width:'40px', height:'40px',}} id="btnCerrar" name="btnCerrar" color="danger" 
        onClick= { () =>{ 
          props.cerrarModal(false,null,null)  //no quiero seguir, no hay jsonNegra, no hay boton
          }} >
        <FontAwesomeIcon color="aquamarine" icon={faWindowClose} /> 
      </Button>
    </Col>
 </Row> 

 {/* Rango de fechas, usuarios, establecimientos */}
  <div id="divBloque1" name="divBloque1" style={{margin:'3%',padding:'2%',background:'black', color:'Fuchsia', borderStyle:'solid', borderColor:'pink'}}>
    {/* Fechas */}
    <Label style={{color:'pink'}}>Fechas</Label>    
    <Row style={{margin:'0',}}>
      <Col>
        <Label>Desde</Label>
        <DatePicker id="txtDesdeCaja" name="txtDesdeCaja" className="anchoDatePickerGenerico" 
          locale='es' dateFormat="dd/MM/yyyy"
          selected={ fechaIniCaja }          
          onChange= { (datePar)  => setfechaIniCaja(datePar) }
        />    
      </Col>
      <Col>
        <Label>Hasta</Label>
        <DatePicker id="txtHastaCaja" name="txtHastaCaja" className="anchoDatePickerGenerico" 
          locale='es' dateFormat="dd/MM/yyyy"
          selected={ fechaFinCaja }          
          onChange= { (datePar)  => setfechaFinCaja(datePar) }
        />
      </Col>
    </Row>
    <hr style={{color:'pink'}}/>
    {/* Usuarios */}
    <Label style={{color:'pink'}}>Usuarios</Label>    
    <Row style={{marginTop:'2%',marginBottom:'1%',marginLeft:'0',marginRight:'0',padding:'0'}}>
      <Col xs="4">
        <Label><Input type="radio" id="usuariosTodos" value="0" name="radioUsuarios" 
          onClick={ () => { document.getElementById("comboUsuarios").value=0 }}        
        /> Todos</Label><br/>      
      </Col>
      <Col xs="8" style ={{display:'flex',textAlign:'right'}}>
        <Label><Input type="radio" id="usuariosSolamente" value="1" name="radioUsuarios" disabled /> Solamente</Label><br/>      
        <Input type="select" name="comboUsuarios" id="comboUsuarios" style={{marginLeft:'2%',width:'58%'}}
          onChange={ () =>{
             document.getElementById("usuariosSolamente").checked = true;
            }} 
        ></Input>
      </Col>
    </Row>
    <hr style={{color:'pink'}}/>

    {/* Establecimientos */}
    <Label style={{color:'pink'}}>Establecimientos</Label>    
    <Row style={{marginTop:'2%',marginBottom:'1%',marginLeft:'0',marginRight:'0',padding:'0'}}>
      <Col xs="4">
        <Label><Input type="radio" id="establecimientosTodos" value="0" name="radioEstablecimientos" 
          onClick={ () => document.getElementById("comboEstablecimientos").value=0 }        
        /> Consolidado</Label><br/>
      </Col>
      <Col xs="8" style ={{display:'flex',textAlign:'right'}}>
        <Label><Input type="radio" id="establecimientosSolamente" value="1" name="radioEstablecimientos" disabled/> Solamente</Label><br/>      
        <Input type="select" name="comboEstablecimientos" id="comboEstablecimientos" style={{marginLeft:'2%',width:'58%'}}
          onChange={ () =>{
            document.getElementById("establecimientosSolamente").checked = true;
           }}         
        ></Input>
      </Col>
    </Row>

  </div> {/* divBloque1 */}

  {/* Boton Aceptar style={{marginRight:'10%'}} */}
  <Row style={{marginTop:'1%',marginBottom:'2%',marginLeft:'0',marginRight:'0',}} >
    <Col >    
      <Button size="md" id="btnExcel" name="btnExcel" color="info" solid="true" 
      onClick={()=>{ salir("E") }}>
      EXCEL</Button>
    </Col>         
    <Col style={{textAlign:'right',}}>    
      <Button size="md" id="btnListo" name="btnListo" color="info" solid="true" 
      onClick={()=>{ salir("P") }}>
      SIGUIENTE</Button>
    </Col>         
  </Row>    

</div> //divMaster
) //del return interno
} //del value
}
</AppContextConsumer>  
)//return externo

}
